export default function XML_StudyPlan() {
  return (
    <div>
      <h1>XML_StudyPlan</h1>
      <p>This is the XML_StudyPlan component.</p>
    </div>
  );
}